import React from "react";

// import "../Dashboard.css";
import "../KidInfo/Quests.css";
import "./Notifications.css";
import BackButton from "../Goback/GoBack";

export const ParentCreateNotification = () => {
  return (
    <>
      <body>
        <div className="container-fluid p-0">
          <div className="p-0" id="mainContent">
            <div className="teacher-bodycontent mb-4">
              <section>
                <div className="container-fluid">
                  <div className="row mb-4">
                    <div className="col-md-12">
                      <BackButton />
                      <p className="tchrdashboard-cmntitl mb-0">
                        Send New Notification
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="Quizzform-layout">
                        <form>
                          <div className="mb-4 d-flex">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label quizzNotifctnLabel"
                            >
                              Recipient Selection
                            </label>
                            <select
                              className="form-control"
                              id="emp"
                              name="emp"
                            >
                              <option>Student</option>
                              <option>Teacher</option>
                              <option>Parent</option>
                            </select>
                          </div>

                          <div className="mb-4 d-flex">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label quizzNotifctnLabel"
                            >
                              Notification Type
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              id="emp"
                              name="emp"
                              placeholder="Title"
                            />
                          </div>

                          <div className="mb-4 d-flex">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label quizzNotifctnLabel"
                            >
                              Notification Content
                            </label>
                            <textarea
                              class="form-control"
                              rows="5"
                              id="comment"
                            ></textarea>
                          </div>

                          <div className="mb-4 d-flex">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label quizzNotifctnLabel"
                            >
                              Media Attachment
                            </label>
                            <input
                              className="form-control"
                              type="file"
                              src=""
                              alt=""
                            />
                          </div>

                          <button className="btn quizzNotifctnBtn mt-4">
                            Send
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};
